import React from "react";

/* Slow-drifting capability pills used as a living background behind a section.
   Positioned toward the edges so they sit behind content, not under it. */

// Kept to the outer margins so they sit beside content, not under it.
const SPOTS = [
  { top: "8%", left: "-1%", cls: "pf-a", o: 0.5 },
  { top: "16%", left: "88%", cls: "pf-b", o: 0.5 },
  { top: "34%", left: "3%", cls: "pf-c", o: 0.42 },
  { top: "30%", left: "92%", cls: "pf-a", o: 0.45 },
  { top: "60%", left: "-2%", cls: "pf-b", o: 0.45 },
  { top: "58%", left: "90%", cls: "pf-c", o: 0.42 },
  { top: "82%", left: "5%", cls: "pf-a", o: 0.48 },
  { top: "86%", left: "86%", cls: "pf-b", o: 0.5 },
];

export default function PillField({ items = [] }) {
  if (!items.length) return null;
  return (
    <div className="pill-field" aria-hidden="true">
      {SPOTS.map((s, i) => (
        <span
          key={i}
          className={`pf ${s.cls}`}
          style={{ top: s.top, left: s.left, opacity: s.o, animationDelay: `${(i % 5) * 0.7}s` }}
        >
          {items[i % items.length]}
        </span>
      ))}
    </div>
  );
}
